import React, { FC, memo } from "react";
import { ISvG } from "~/types/SvGTypes";

const Icon: FC<ISvG> = ({ fill = "#FFF" }) => {
  return (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      id="magicoon-Filled"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="sort-ascending-Filled">
        <path
          fill={fill}
          d="M12,2.5A9.5,9.5,0,1,0,21.5,12,9.509,9.509,0,0,0,12,2.5ZM11,7h2a1,1,0,0,1,0,2H11a1,1,0,0,1,0-2ZM9.5,11h5a1,1,0,0,1,0,2h-5a1,1,0,0,1,0-2ZM16,17H8a1,1,0,0,1,0-2h8a1,1,0,0,1,0,2Z"
        />
      </g>
    </svg>
  );
};

export default memo(Icon);
